export default "__VITE_ASSET__BU1z0Xgy__"